import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import img from '../../../../../assets/images/mep-default.png.js';
import img$1 from '../../../../../assets/images/chevron_right.svg.js';

function renderCard(card, onOpen) {
    const hasDescription = Boolean(card.meta);
    const hasLink = Boolean(card.modalPrimaryCtaLink);
    const imageTemplate = $ `<div class="gallery-card-image"><img src="${card.imageSrc || img}" alt="${card.imageAlt || ''}" loading="lazy"></div>`;
    const descriptionTemplate = hasDescription
        ? $ `<div class="gallery-card-description">${card.meta}</div>`
        : w;
    const linkTemplate = hasLink
        ? $ `<span class="gallery-card-link">Link <img src="${img$1}" alt="" class="arrow-icon"></span>`
        : w;
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onOpen(card);
        }
    };
    return $ `<article class="gallery-card"><button class="gallery-card-button" type="button" @click="${() => onOpen(card)}" @keydown="${handleKeyDown}" aria-label="${card.title}">${imageTemplate}<div class="gallery-card-content"><h3 class="gallery-card-title">${card.title}</h3>${descriptionTemplate} ${linkTemplate}</div></button></article>`;
}

export { renderCard };
